import Repository from '@/repositories/marketing'
const resource = '/workflows'

export default {
  fetch(config) {
    return Repository.get(`${resource}.json`, config)
  },
  getJourneyById(id){
    return Repository.get(`${resource}/${id}.json`)
  },
  create(payload, config) {
    return Repository.post(`${resource}.json`,payload, config)
  },
  update(id, payload, config) {
    return Repository.put(`${resource}/${id}.json`, payload, config)
  },
  checkIfJourneyNameExists(config){
    return Repository.get(`${resource}/journey_present_by_name.json`, config)
  },
  export(id) {
    return Repository.get(`${resource}/${id}/export.json`)
  },
  delete(config) {
    return Repository.delete(`${resource}/bulk_delete.json`, config)
  },
  refresh(id) {
    return Repository.get(`${resource}/${id}/refresh_contacts_count.json`)
  },
  bulkRefresh(config) {
    return Repository.post(`${resource}/bulk_refresh.json`, config)
  },
  templateList(config){
    return Repository.get(`${resource}/journey_templates.json`, config)
  },
  journeyBuilder(id, payload, config){
    return Repository.post(`${resource}/${id}/create_workflow_via_template.json`, payload, config)
  },
  getTemplateData(name){
    return Repository.get(`${resource}/show_workflow_template.json?template_name=${name}`)
  }
}